import { IViolation } from 'app/model/base/annotation';
import { IModel, IAttribute } from '../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { Dataset } from './dataset';
import { FileFormat } from './file-format';
import { Compression } from './compression';

import { fileFormats } from 'app/shared/components/fileformat/fileformat.constants';
import { containWilcard } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    abstract: true
})
export abstract class FileTypeDataset extends Dataset {
    public static readonly MODEL: IModel;
    public static readonly FOLDER_PATH: IAttribute;
    public static readonly FILE_NAME: IAttribute;
    public static readonly WILDCARD_PATH: IAttribute;
    public static readonly FILE_FORMAT: IAttribute;
    public static readonly MODIFID_DATETIME_START: IAttribute;
    public static readonly MODIFID_DATETIME_END: IAttribute;

    @Metamodel.attribute({
        display: stringResources.FolderPath_Label,
        association: 'FOLDER_PATH',
        templatable: true,
        constraint: {
            validator: FileTypeDataset.validateFolderPath
        }
    })
    public folderPath?: string;

    @Metamodel.attribute({
        display: stringResources.FileNameLabel,
        association: 'FILE_NAME',
        templatable: true,
        constraint: {
            validator: FileTypeDataset.validateFileName
        }
    })
    public fileName?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_WildcardPath,
        association: 'WILDCARD_PATH',
        templatable: true
    })
    public wildcardPath?: string;

    @Metamodel.attribute({
        type: FileTypeDataset.referTypeFileFormat,
        association: 'FILE_FORMAT'
    })
    public format?: FileFormat;

    @Metamodel.attribute({
        display: stringResources.ModelName_ModifiedDatetimeStart,
        association: 'MODIFID_DATETIME_START',
        templatable: true
    })
    public modifiedDatetimeStart?: Date;

    @Metamodel.attribute({
        display: stringResources.ModelName_ModifiedDatetimeEnd,
        association: 'MODIFID_DATETIME_END',
        templatable: true
    })
    public modifiedDatetimeEnd?: Date;

    public compression?: Compression;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }

    private static referTypeFileFormat(): IModel {
        return FileFormat.MODEL;
    }

    private static validateFolderPath(owner: FileTypeDataset, value: string): IViolation[] {
        if (Metamodel.modelOf(owner).name === 'AzureBlob') {
            if (owner.folderPath && containWilcard(owner.folderPath.split('/')[0])) {
                return [{
                    message: () => stringResources.WildcardBlobContainerError
                }];
            }
        }
        if (__IS_FABRIC_DPE__ &&
            (Metamodel.modelOf(owner).name === adfModelTypeMap.azureDataLakeStoreCosmosStructuredStream.datasetType
            || Metamodel.modelOf(owner).name === adfModelTypeMap.azureDataLakeStoreGen2CosmosStructuredStream.datasetType)) {
            if(!owner.folderPath) {
                return [{
                    message: () => stringResources.AdlsCosmosFolderPathMissingError
                }];
            }
        }
        return undefined;
    }

    private static validateFileName(owner: FileTypeDataset, value: string): IViolation[] {
        if (__IS_FABRIC_DPE__ &&
            (Metamodel.modelOf(owner).name === adfModelTypeMap.azureDataLakeStoreCosmosStructuredStream.datasetType
            || Metamodel.modelOf(owner).name === adfModelTypeMap.azureDataLakeStoreGen2CosmosStructuredStream.datasetType)) {
            if (!owner.fileName) {
                return [{
                    message: () => stringResources.AdlsCosmosFileNameMissingError
                }];
            }
        }
        return undefined;
    }
}

export function isDatasetWithoutFileFormat(dataset: FileTypeDataset): boolean {
    if (Metamodel.modelOf(dataset).name === adfModelTypeMap.azureDataLakeStoreCosmosStructuredStream.datasetType
    || Metamodel.modelOf(dataset).name === adfModelTypeMap.azureDataLakeStoreGen2CosmosStructuredStream.datasetType) {
        return false;
    }
    return dataset.format == null || dataset.format.type === fileFormats.noFormat;
}
